module.exports = __webpack_public_path__ + "img/LabXRA_logo.615b6aec.png";